const edges = [
  { data: { source: 'mec-info', target: 'sulh' } },
  { data: { source: 'mec-rec', target: 'recupero' } },
  { data: { source: 'mec-rp', target: 'sic' } },
  { data: { source: 'mec-inmuebles', target: 'inmuebles' } },
  { data: { source: 'mec-muni', target: 'rafam' } },
  { data: { source: 'mec-muni', target: 'simco' } },
  { data: { source: 'mec-est', target: 'censos' } },
  { data: { source: 'mec-ip', target: 'bapin' } },
  { data: { source: 'mec-pt', target: 'reca-et' }, classes: 'manual' },
  { data: { source: 'mec-eclab', target: 'siape' }, classes: 'manual' },
  { data: { source: 'mec-eclab', target: 'sulh' }, classes: 'manual' },
  { data: { source: 'cgp', target: 'sigaf' } },
  { data: { source: 'tgp', target: 'transf' } },
  { data: { source: 'tgp', target: 'sigaf' } },
  { data: { source: 'transf', target: 'bapro' } },
  { data: { source: 'reca-cat', target: 'arba-inmuebles' } },
  { data: { source: 'reca-cat', target: 'arba-geo' } },
  { data: { source: 'sg-empleo', target: 'siape' } },
  { data: { source: 'dpsit', target: 'siep' } },
  { data: { source: 'dpsit', target: 'form' } },
  { data: { source: 'minfra', target: 'tablero' } },
  { data: { source: 'minfra', target: 'seguimiento' } },
  { data: { source: 'seguimiento', target: 'sigaf' } },
  { data: { source: 'recupero', target: 'siep' } },
  { data: { source: 'recupero', target: 'sigaf' } },
  { data: { source: 'recupero', target: 'samo' }, classes: 'manual' },
  { data: { source: 'sulh', target: 'sigaf' }, classes: 'manual' },
  { data: { source: 'sulh', target: 'siape' } },
  { data: { source: 'sic', target: 'sigaf' } },
  { data: { source: 'sic', target: 'arba-inmuebles' } },
  { data: { source: 'inmuebles', target: 'arba-inmuebles' } },
  { data: { source: 'inmuebles', target: 'arba-geo' } },
  { data: { source: 'msalud', target: 'fact' } },
  { data: { source: 'msalud', target: 'sipach' } },
  { data: { source: 'bapro', target: 'bapro-Copa' } },
  { data: { source: 'opc', target: 'pbac' } },
  { data: { source: 'sigaf', target: 'pbac' } },
  { data: { source: 'ioma', target: 'sigaf' }, classes: 'manual' },
  { data: { source: 'histsal', target: 'sulh' } },
  { data: { source: 'histsal', target: 'sigaf' } },
  { data: { source: 'histsal', target: 'transf' } },
  { data: { source: 'histsal', target: 'bapro' } },
  { data: { source: 'histsal', target: 'mec-eclab' } },
  { data: { source: 'histsal', target: 'tgp' } },
  { data: { source: 'histsal', target: 'siape' } },
  { data: { source: 'esc-hv', target: 'dgcye-rrhh' } },
  { data: { source: 'esc-lic', target: 'dgcye-rrhh' } },
  { data: { source: 'esc-suna', target: 'dgcye-rrhh' } },
  { data: { source: 'esc-art', target: 'dgcye-rrhh' } },
  { data: { source: 'esc-host', target: 'dgcye-rrhh' } },
  { data: { source: 'dgcye-educ', target: 'esc-aux' } },
  { data: { source: 'dgcye-educ', target: 'esc-coope' } },
  { data: { source: 'dgcye-plan', target: 'esc-boletin' } },
  { data: { source: 'dgcye-plan', target: 'esc-aprender' } },
  { data: { source: 'dgcye-fin', target: 'esc-sicoinse' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-apd' } },
  { data: { source: 'dgcye-fin', target: 'esc-f572' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-of' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-of' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-priv' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-priv' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-inc' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-inc' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-incp' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-incp' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-conn' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-conn' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-incn' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-incn' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-alc' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-alc' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-alc' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-rec' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-viat' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-viat' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-hext' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-hext' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-tps' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-tps' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-boni' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-boni' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-fam' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-fam' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-priv-adic' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-priv-adic' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-inasis' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-inasis' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-priv-ret' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-priv-ret' } },
  { data: { source: 'dgcye-fin', target: 'esc-liq-afip' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-liq-afip' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-rrhh-of' } }, 
  { data: { source: 'dgcye-rrhh', target: 'esc-rrhh-priv' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-mad' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-tit' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-receso' } },
  { data: { source: 'dgcye-fin', target: 'esc-dineraria-art' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-dineraria-art' } },
  { data: { source: 'dgcye-fin', target: 'esc-hhee' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-hhee' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-jub-cert' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-fojero' } },
  { data: { source: 'dgcye-fin', target: 'esc-op' } },
  { data: { source: 'dgcye-fin', target: 'esc-anticipo' } },
  { data: { source: 'dgcye-rrhh', target: 'esc-anticipo' } },
  { data: { source: 'dgcye-plan', target: 'esc-est' } },
  { data: { source: 'dgcye-educ', target: 'esc-prov-sup' } },
  { data: { source: 'rupa', target: 'ips' } },
  { data: { source: 'sap', target: 'ips' } },
  { data: { source: 'autogestion', target: 'ips' } },
  { data: { source: 'webijd', target: 'ips'} },
  { data: { source: 'siceep', target: 'ips'} },
  { data: { source: 'ips-deudas', target: 'ips' } },
  { data: { source: 'ips-fallecidos', target: 'ips' } },
]

export default edges

